/**
 * Config Version Service
 *
 * Reads the config-convergence state that devices echo back in their heartbeat
 * (`configVersion`), as opposed to the config we believe we sent them.
 *
 * Backend: /api/orgs/{orgId}/config-updates
 */
import apiClient from './apiClient';

const configVersionService = {
  /**
   * Org-wide rollup of how many devices are converged / drifted / not reporting.
   * @param {number} orgId
   * @returns {Promise<Object>} ConfigDriftSummaryResponse
   */
  getDriftSummary: async (orgId) => {
    const { data } = await apiClient.get(`/api/orgs/${orgId}/config-updates/drift-summary`);
    return data;
  },

  /**
   * Convergence state of every device the given profile governs, including those whose
   * push has not landed yet.
   * @param {number} orgId
   * @param {number} profileId
   * @param {string} [state] optional sync state filter
   * @returns {Promise<Array>} DeviceConfigVersionResponse[]
   */
  listDevicesByProfile: async (orgId, profileId, state) => {
    const { data } = await apiClient.get(
      `/api/orgs/${orgId}/config-updates/profiles/${profileId}/devices`,
      { params: state ? { state } : undefined },
    );
    return Array.isArray(data) ? data : [];
  },

  /**
   * Convergence state of a single device.
   * @param {number} orgId
   * @param {number} deviceId
   * @returns {Promise<Object>} DeviceConfigVersionResponse
   */
  getDeviceConfigVersion: async (orgId, deviceId) => {
    const { data } = await apiClient.get(
      `/api/orgs/${orgId}/config-updates/devices/${deviceId}`,
    );
    return data;
  },
};

export default configVersionService;
